var Student = "Öğrenci";
var jobRole = {
	"Job role": "İş Görevi",
	"Academic / Researcher": "Akademisyen/Araştırmacı",
	"Advisor / Consultant": "Müşavir/Danışman",
	"Business Executive": "İş Yöneticisi",
	"Developer / Engineer": "Geliştirici/Mühendis",
	"Entrepreneur (Founder/Co-Founder)": "Girişimci (Kurucu/Kurucu Ortak)",
	"IT Executive": "BT Yöneticisi",
	"IT Professional or Technical Manager": "BT Uzmanı veya Teknik Yönetici",
	"Press / Media Analyst": "Basın/Medya Analisti",
	"Sales / Marketing": "Satış/Pazarlama",
	Student: Student,
	"Solution or Systems Architect": "Çözüm veya Sistem Mimarı",
	"System Administrator": "Sistem Yöneticisi",
	"Venture Capitalist": "Risk Sermayedarı"
};

export { Student, jobRole as default };
